import { Component, OnInit,ViewChild, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';
import {Observable, of, fromEvent} from 'rxjs';
import {catchError, debounceTime, distinctUntilChanged, map, tap, switchMap, first, filter} from 'rxjs/operators';
import{HeaderService} from './header.service';
import { AuthenticationService } from '../login/authentication.service';
import { environment } from '../../environments/environment';
import {Router,ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd } from '@angular/router';
import { PageHeaderReport, ShellService, InspectionServiceKind } from '../shell/shell.service';
import { NavSection } from '../shell/nav-menu';
import { SettingsMenuService } from '../settings/settings-menu.service';
import { WeatherEstimate, WeatherEstimateService } from '../inspector-dashboard/weather-estimate.service';

@Component({
  selector: 'abe-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @ViewChild('siteSearchInput') siteSearchInput: ElementRef;
  exists: any = [];
    public apiSite;
    public old_site;
    public oldSite;
    headerText:any = '';
    model: any;
    searching = false;
    searchFailed = false;
    searchparam = '';

    // The bell is a disabled "Coming Soon" launcher (mockup); notifications are not built yet.
    accountMenuOpen = false;
    initials = '';
    fullName = '';
    roleLabel = '';
    // Optional page heading, set per route with data: { title, subtitle }. Without one the
    // top bar is compact (search + account only) and pages keep their own headings.
    pageTitle = '';
    pageSubtitle = '';
    // Heading a page sets itself through ShellService.setPageHeader (wins over route data).
    headerTitle = '';
    headerSubtitle = '';
    headerSubtitleLink = '';
    headerStruck = false;
    // Inspection pages: the address title opens the order's reports (mockup property-reports).
    headerReports: PageHeaderReport[] = [];
    reportsOpen = false;
    // Inspection pages: Home / Termite Inspection (read-only when jobServiceChange is null).
    jobService: InspectionServiceKind = null;
    jobServiceChange: (service: InspectionServiceKind) => void = null;
    readonly services: { value: InspectionServiceKind, label: string }[] = [
        { value: 'home', label: 'Home' },
        { value: 'termite', label: 'Termite' }
    ];

    pickService(service: InspectionServiceKind) {
        if (this.jobServiceChange && service !== this.jobService) {
            this.jobServiceChange(service);
        }
    }
    // Notifications bell: shows "coming soon" while it is open.
    bellOpen = false;
    // Dashboard heading row: "Dashboard", today's date and a weather estimate.
    showGreeting = false;
    greeting = '';
    today = new Date();
    weather: WeatherEstimate = null;
    private companyCity = '';
    private greetingTimer: any = null;

  	constructor(
      private headerService: HeaderService,
      private authenticationService: AuthenticationService,
      private  _router : Router,
      private el: ElementRef,
      public shell: ShellService,
      private weatherEstimate: WeatherEstimateService,
      private settingsMenu: SettingsMenuService
    ) { }
    private settingsSections: NavSection[] = [];
  	public userData;
  	ngOnInit() {
      this.old_site = environment.apiSite;
  		this.userData = JSON.parse(localStorage.getItem('user')) || {};
      this.apiSite = environment.apiSite;
      this.oldSite = environment.oldSite;
      this.headerText = environment.appDashboard;
      this.setAccount();
      this.shell.loadAccountPhoto();
      this.newSiteSearch();
      this.newPasteEvent();
      this.readPageTitle();
      this.settingsMenu.sections$.subscribe(sections => {
        this.settingsSections = sections;
        this.readPageTitle();
      });
      this._router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => {
        this.accountMenuOpen = false;
        this.readPageTitle();
      });
      this.shell.settings$.subscribe(settings => {
        this.companyCity = settings.setting_company_city || '';
        this.refreshGreeting();
      });
      this.shell.pageHeader$.subscribe(header => {
        this.showGreeting = !!(header && header.greeting);
        this.headerTitle = (header && header.title) || '';
        this.headerSubtitle = (header && header.subtitle) || '';
        this.headerSubtitleLink = (header && header.subtitleLink) || '';
        this.headerStruck = !!(header && header.struck);
        this.headerReports = (header && header.reports) || [];
        this.jobService = (header && header.service) || null;
        this.jobServiceChange = (header && header.serviceChange) || null;
        this.reportsOpen = false;
        this.refreshGreeting();
        // Keep the date / the temperature current while the dashboard stays open.
        clearInterval(this.greetingTimer);
        this.greetingTimer = this.showGreeting ? setInterval(() => this.refreshGreeting(), 5 * 60 * 1000) : null;
      });
		}
    refreshGreeting(){
      if (!this.showGreeting) {
        return;
      }
      this.today = new Date();
      // Mockup "Administrator Dashboard" / "Inspector Dashboard": one "Dashboard" for every role.
      this.greeting = 'Dashboard';
      this.weather = this.weatherEstimate.estimate(this.companyCity, this.today);
    }
    setAccount(){
      const first = (this.userData.user_first_name || '').trim();
      const last = (this.userData.user_last_name || '').trim();
      this.fullName = (first + ' ' + last).trim();
      this.initials = ((first.charAt(0) || '') + (last.charAt(0) || '')).toUpperCase();
      const level = this.userData.user_level || '';
      this.roleLabel = level.charAt(0).toUpperCase() + level.slice(1);
    }
    readPageTitle(){
      let route: ActivatedRouteSnapshot = this._router.routerState.snapshot.root;
      while (route.firstChild) {
        route = route.firstChild;
      }
      this.pageTitle = (route.data && route.data.title) || '';
      this.pageSubtitle = (route.data && route.data.subtitle) || '';
      // Pages in the Settings list (many are lazy modules without route data) share the mockup heading.
      if (!this.pageTitle && SettingsMenuService.find(this.settingsSections, this._router.url)) {
        this.pageTitle = 'Settings';
        this.pageSubtitle = 'Manage account, operational, reporting, and data preferences.';
      }
    }
    toggleAccountMenu(event: Event){
      event.stopPropagation();
      this.accountMenuOpen = !this.accountMenuOpen;
    }
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event){
      if (this.accountMenuOpen && !this.el.nativeElement.querySelector('.im-account').contains(event.target)) {
        this.accountMenuOpen = false;
      }
      const reports = this.el.nativeElement.querySelector('.im-reports');
      if (this.reportsOpen && reports && !reports.contains(event.target)) {
        this.reportsOpen = false;
      }
    }
    // Show Setup Guide: un-hides the dashboard setup guide (its steps follow the user type) and
    // opens the dashboard on it.
    showSetupGuide() {
      this.accountMenuOpen = false;
      if (this.shell.get('setup_guide_hidden', false) === true) {
        this.shell.set('setup_guide_hidden', false);
      }
      this._router.navigate(['/dashboard']).then(() => setTimeout(() => {
        const guide = document.getElementById('sgTitle');
        if (guide) {
          guide.scrollIntoView({ block: 'start' });
          guide.focus();
        }
      }, 300));
    }

    // Help & Support: the sidebar's Help (Milo) panel.
    openHelp() {
      this.accountMenuOpen = false;
      setTimeout(() => {
        const help = document.getElementById('imHelpButton');
        if (help) {
          help.click();
        }
      });
    }

    // A full load, as the old switcher did: inspection pages read their job id once.
    reportHref(link: string): string {
      return new URL(link.replace(/^\//, ''), document.baseURI).href;
    }

    @HostListener('document:keydown.escape')
    onEscape(){
      if (this.reportsOpen) {
        this.reportsOpen = false;
        const trigger = this.el.nativeElement.querySelector('.im-reports-trigger');
        if (trigger) {
          trigger.focus();
        }
      }
      this.accountMenuOpen = false;
      this.searchResults = false;
    }
    get hasResults(){
      return (this.searchJobs && this.searchJobs.length) || (this.searchProperties && this.searchProperties.length) || (this.searchClients && this.searchClients.length);
    }
		signOut(){
			localStorage.removeItem('app_token');
      localStorage.removeItem('user');
      ShellService.clearCache();
      window.location.href = '/login';
      // this.authenticationService.signOut()
      // .subscribe(
      //   data => {
      //     console.log(data);
      //     localStorage.removeItem('app_token');
      //     localStorage.removeItem('user');
      //     window.location.href = '/login';
      //   },error=>{
      //     // localStorage.removeItem('app_token');
      //     // localStorage.removeItem('user');
      //     console.log(error);
      //   }
      // );
		}
    redirectInspection(data){
      // window.location.href = this.apiSite+'url/inspections_completed_sheet/'+data.item.job_id;
      this._router.navigate(['inspections-completed-sheet/',data.item.job_id]);
    }
    searchResults = false;
    isSearching = false;
    searchJobs: any[] = [];
    searchProperties: any[] = [];
    searchClients: any[] = [];

    searchApiSite(){
      if(!this.isSearching){
        this.isSearching = true;
        setTimeout(() => {
          this.headerService.searchSite(this.searchparam).subscribe(
              data => { 
                  this.searchResults = true;
                  this.isSearching = false;
                  this.searchJobs = data.jobs
                  this.searchClients = data.clients
                  this.searchProperties = data.properties
              }
          );
        }, 500);
      }
      
    }
    newSiteSearch(){
      const search$ = fromEvent(this.siteSearchInput.nativeElement, 'keyup').pipe(
        map((event: any) => event.target.value),
        debounceTime(300),  
        distinctUntilChanged(),
        tap(()=> this.isSearching = true),
        switchMap((term) => term ? this.headerService.searchSite(term) : of<any>(this.exists)),
        tap(() => {
            this.searchComplete();
        })
      );

      search$.subscribe(data => {
        this.searchDone(data);
      })
    }

    newPasteEvent(){
      const search$ = fromEvent(this.siteSearchInput.nativeElement, 'paste').pipe(
        map((event: any) => event.target.value),
        debounceTime(300),  
        distinctUntilChanged(),
        tap(()=> this.isSearching = true),
        switchMap((term) => term ? this.headerService.searchSite(term) : of<any>(this.exists)),
        tap(() => {
            this.searchComplete();
        })
      );

      search$.subscribe(data => {
        this.searchDone(data);
      })
    }

    searchComplete(){
        this.isSearching = false,
        this.searchResults = true;
    }
    searchDone(data){
        this.isSearching = false
        this.searchJobs = data.jobs
        this.searchClients = data.clients
        this.searchProperties = data.properties
    }
    navigateFromSearch(data){
      // window.location.href = this.apiSite+'url/inspections_completed_sheet/'+data.job_id;
      //this._router.navigate(['inspections-completed-sheet/',data.job_id]);
        window.location.href = 'inspections-completed-sheet/'+data.job_id;
    }
    onClickedOutside(e: Event) {
      this.searchResults = false;
    }
    search = (text$: Observable<string>) =>
    text$.pipe(
          debounceTime(300),
          distinctUntilChanged(),
          tap(() => this.searching = true),
          switchMap(term =>
          this.headerService.getClients(term).pipe(
              tap(() => {this.searchFailed = false} ),
              catchError(() => {
               this.searchFailed = true;
                return of([]);
              }))
          ),
          tap(() => this.searching = false)
    )
    formatter = (x: {text: string}) => x.text;

}
